import axios, { isAxiosError } from 'axios'
import authService from '../Services/auth'
import { server } from '../constants'
import { appStore } from '../redux/store'
import { setError } from '../redux/actions/error.action'
import { checkApiUnauthorized } from '../helpers/checkApiUnauthorized'

const etrBackend = axios.create({
  baseURL: server.BASE_URL,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  },
  transformRequest: [
    function (data, headers) {
      // You may modify the headers object here
      if (headers) headers['Authorization'] = `Bearer ${authService.accessToken()}`
      // Do not change data
      return JSON.stringify(data)
    }
  ]
})

// etrBackend.interceptors.response.use(
//   function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response
//   },
//   function (error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     // const iggnoreStatus = [403, 504, 502]
//     // if (!iggnoreStatus.includes(error.response?.status)) {
//     //   appStore.dispatch(setError(error))
//     // }

//     checkApiUnauthorized(error)

//     // console.log()

//     return Promise.reject(error)
//   }
// )

export default etrBackend
